import { render, staticRenderFns } from "./s-contract-info.vue?vue&type=template&id=bddd97e6&"
import script from "./s-contract-info.vue?vue&type=script&lang=js&"
export * from "./s-contract-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports